export class ResponseFormatError extends Error {
  name = 'SCP_RESPONSE_FORMAT_ERROR' as const;

  public constructor(response: unknown) {
    super(`Invalid SCP response format: ${JSON.stringify(response)}`);
  }
}

export class HttpError extends Error {
  status: number;
  code?: string;
  name = 'HTTP_ERROR' as const;
  body?: any;

  constructor(options: { message: string; status: number; code?: string }) {
    const { message, status, code, ...rest } = options;
    super(message);
    this.status = status;
    this.code = code;
    this.body = rest;
  }
}

export class AbortError extends Error {
  name = 'ABORT_ERROR' as const;

  constructor(options: { message: string }) {
    super(options.message);
  }
}

export class TimeoutError extends Error {
  name = 'TIMEOUT_ERROR' as const;

  constructor(options: { message: string }) {
    super(options.message);
  }
}

export type RequestError =
  | HttpError
  | AbortError
  | TimeoutError
  | ResponseFormatError;
